import { Form, Grid } from 'antd';
import { Modal } from 'components';
import {
  RoleFormField,
  RoleFormValues,
} from 'features/role-management/components/role-filter-field/type';
import { useEditRole } from 'features/role-management/use-cases/edit-role';
import { useGetRoleById } from 'features/role-management/use-cases/get-role';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { RoleInfoFormItems } from './role-info-item';
const { useBreakpoint } = Grid;
export const EditRoleViewModal = ({
  onClose,
  editRoleData,
}: {
  onClose: () => void;
  editRoleData: any;
}) => {
  const formName = 'add-user-form';
  const screens = useBreakpoint();
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<RoleFormValues>();
  const { t } = useTranslation();
  const userQueryResult: any = useGetRoleById(editRoleData?.Id, {
    cacheTime: 0,
  });
  const { isFetching } = userQueryResult;
  const { isLoading, mutate } = useEditRole();
  const [switchStates, setSwitchStates] = useState<{ [key: string]: boolean }>(
    {},
  );
  useEffect(() => {
    if (userQueryResult?.data?.rc) {
      const initialState: { [key: string]: boolean } = {};
      userQueryResult?.data?.rc.forEach((item: any) => {
        initialState[item.Id] = item.IsChecked ?? false; // Set default to false if IsChecked is undefined
      });
      setSwitchStates(initialState);
    }
  }, [userQueryResult?.data]);
  const getInitialValues = {
    [RoleFormField.RoleName]: editRoleData.RoleName,
  };
  const handleUpdate = (values: any) => {
    const payload: any = {
      RoleName: values.RoleName, // From form input
      RoleId: editRoleData.Id,
      PermissionIds: Object.keys(switchStates)
        .filter((id) => switchStates[id]) // Filter only checked permissions
        .map((id) => ({
          id: Number(id), // Convert id to number (if needed)
        })),
    };

    mutate(payload, { onSuccess: onClose });
  };

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        centered
        title={t('rolemanagement.modal.title')}
        onCancel={onClose}
        getContainer={false}
        onOk={form.submit}
        okText={t('rolemanagement.modal.editbutton')}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={screens.lg ? '520px' : '100%'}
        okButtonProps={{
          form: formName,
          loading: isLoading,
        }}
      >
        <Form<RoleFormValues>
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          initialValues={getInitialValues}
          onFinish={handleUpdate}
          onFinishFailed={() => {
            setValidateTrigger(['onChange']);
          }}
          validateTrigger={validateTrigger}
          disabled={isLoading}
        >
          <RoleInfoFormItems
            data={userQueryResult?.data}
            isFetching={isFetching}
            switchStates={switchStates}
            setSwitchStates={setSwitchStates}
          />
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
